import { type ReactElement, type ElementType } from 'react';
import { type ArticleContent } from 'types/wellbeing';
import { STYLES } from '../../styles';
import { processTextWithBold } from '../../utils';

interface HeadingContentProps {
  contentItem: ArticleContent;
}

const HeadingContent = ({ contentItem }: HeadingContentProps): ReactElement => {
  const level = contentItem.level || 2;
  const HeadingTag = `h${level}` as ElementType;

  return (
    <HeadingTag className={STYLES.HEADING}>
      {processTextWithBold(contentItem.text || '')}
    </HeadingTag>
  );
};

export default HeadingContent;
